var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-wallet",
    viewBox: "0 0 128 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color1, #24cca7)"
    },
    d: "M3.755 7.619l16.211-4.537-0.858-1.779c-0.562-1.157-1.932-1.634-3.060-1.058l-14.513 7.375h2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color1, #24cca7)"
    },
    d: "M24.813 3.048c-0.195 0-0.391 0.029-0.586 0.087l-15.012 4.484h18.431l-0.693-2.779c-0.266-1.083-1.163-1.793-2.14-1.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color2, #4a56e2)"
    },
    d: "M28.36 8.573h-26.559c-0.568 0-1.074 0.26-1.405 0.67-0.151 0.189-0.266 0.406-0.331 0.645-0.040 0.15-0.065 0.307-0.065 0.467v19.862c0 0.984 0.805 1.783 1.797 1.783h26.559c0.992 0 1.797-0.799 1.797-1.783v-4.973h-10.662c-1.685 0-3.055-1.358-3.055-3.030v-3.965c0-0.82 0.331-1.565 0.866-2.111 0.474-0.485 1.11-0.813 1.822-0.895 0.119-0.014 0.241-0.021 0.363-0.021h10.665v-4.867c0.004-0.984-0.801-1.783-1.793-1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color2, #4a56e2)"
    },
    d: "M31.414 16.926c-0.18-0.164-0.392-0.289-0.629-0.371-0.183-0.061-0.377-0.096-0.582-0.096h-10.712c-0.992 0-1.797 0.799-1.797 1.783v3.968c0 0.984 0.805 1.783 1.797 1.783h10.712c0.205 0 0.399-0.036 0.582-0.096 0.237-0.078 0.449-0.207 0.629-0.371 0.359-0.324 0.586-0.795 0.586-1.316v-3.968c0-0.521-0.226-0.991-0.586-1.316zM23.243 20.581c0 0.492-0.402 0.891-0.898 0.891h-0.596c-0.496 0-0.898-0.399-0.898-0.891v-0.592c0-0.285 0.133-0.538 0.345-0.699 0.154-0.118 0.345-0.192 0.553-0.192h0.596c0.496 0 0.898 0.399 0.898 0.891v0.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M72.672 7.952l-4.392 16.848h-4.968l-2.688-11.088-2.784 11.088h-4.968l-4.272-16.848h4.392l2.424 12.264 3-12.264h4.512l2.88 12.264 2.448-12.264h4.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M73.914 18.080c0-1.376 0.256-2.584 0.768-3.624 0.528-1.040 1.24-1.84 2.136-2.4s1.896-0.84 3-0.84c0.944 0 1.768 0.192 2.472 0.576 0.72 0.384 1.272 0.888 1.656 1.512v-1.896h4.104v13.392h-4.104v-1.896c-0.4 0.624-0.96 1.128-1.68 1.512-0.704 0.384-1.528 0.576-2.472 0.576-1.088 0-2.080-0.28-2.976-0.84-0.896-0.576-1.608-1.384-2.136-2.424-0.512-1.056-0.768-2.272-0.768-3.648zM83.946 18.104c0-1.024-0.288-1.832-0.864-2.424-0.56-0.592-1.248-0.888-2.064-0.888s-1.512 0.296-2.088 0.888c-0.56 0.576-0.84 1.376-0.84 2.4s0.28 1.84 0.84 2.448c0.576 0.592 1.272 0.888 2.088 0.888s1.504-0.296 2.064-0.888c0.576-0.592 0.864-1.4 0.864-2.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M95.123 7.040v17.76h-4.104v-17.76h4.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M102.201 7.040v17.76h-4.104v-17.76h4.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M117.799 17.888c0 0.384-0.023 0.784-0.071 1.2h-9.289c0.064 0.832 0.329 1.472 0.793 1.92 0.48 0.432 1.063 0.648 1.751 0.648 1.024 0 1.737-0.432 2.137-1.296h4.368c-0.224 0.88-0.633 1.672-1.225 2.376-0.576 0.704-1.303 1.256-2.183 1.656s-1.865 0.6-2.953 0.6c-1.312 0-2.48-0.28-3.504-0.84s-1.824-1.36-2.4-2.4c-0.576-1.040-0.864-2.256-0.864-3.648s0.28-2.608 0.84-3.648c0.576-1.040 1.376-1.84 2.401-2.4s2.199-0.84 3.527-0.84c1.296 0 2.448 0.272 3.456 0.816s1.792 1.32 2.352 2.328c0.576 1.008 0.864 2.184 0.864 3.528zM113.6 16.808c0-0.704-0.24-1.264-0.72-1.68s-1.081-0.624-1.801-0.624c-0.688 0-1.271 0.2-1.751 0.6-0.464 0.4-0.752 0.968-0.864 1.704h5.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color3, #000)"
    },
    d: "M127.428 21.32v3.48h-2.087c-1.488 0-2.649-0.36-3.481-1.080-0.832-0.736-1.248-1.928-1.248-3.576v-5.328h-1.632v-3.408h1.632v-3.264h4.105v3.264h2.688v3.408h-2.688v5.376c0 0.4 0.096 0.688 0.288 0.864s0.512 0.264 0.96 0.264h1.463z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-email",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.333 5.333h-21.333c-1.467 0-2.653 1.2-2.653 2.667l-0.013 16c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-16c0-1.467-1.2-2.667-2.667-2.667zM27.333 10.667l-10.667 6.667-10.667-6.667v-2.667l10.667 6.667 10.667-6.667v2.667z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-password",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.667 10.667h-1.333v-2.667c0-3.68-2.987-6.667-6.667-6.667s-6.667 2.987-6.667 6.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v13.333c0 1.467 1.2 2.667 2.667 2.667h16c1.467 0 2.667-1.2 2.667-2.667v-13.333c0-1.467-1.2-2.667-2.667-2.667zM16.667 22.667c-1.467 0-2.667-1.2-2.667-2.667s1.2-2.667 2.667-2.667c1.467 0 2.667 1.2 2.667 2.667s-1.2 2.667-2.667 2.667zM20.8 10.667h-8.267v-2.667c0-2.28 1.853-4.133 4.133-4.133s4.133 1.853 4.133 4.133v2.667z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-username",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 6.667v18.667c0 1.467 1.187 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667v-18.667c0-1.467-1.2-2.667-2.667-2.667h-18.667c-1.48 0-2.667 1.2-2.667 2.667zM20.667 12c0 2.213-1.787 4-4 4s-4-1.787-4-4c0-2.213 1.787-4 4-4s4 1.787 4 4zM8.667 22.667c0-2.667 5.333-4.133 8-4.133s8 1.467 8 4.133v1.333h-16v-1.333z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-wallet2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color1, #24cca7)"
    },
    d: "M3.755 7.619l16.211-4.537-0.858-1.779c-0.562-1.157-1.932-1.634-3.060-1.058l-14.513 7.375h2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24cca7",
    style: {
      fill: "var(--color1, #24cca7)"
    },
    d: "M24.813 3.048c-0.195 0-0.391 0.029-0.586 0.087l-15.012 4.484h18.431l-0.693-2.779c-0.266-1.083-1.163-1.793-2.14-1.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color2, #4a56e2)"
    },
    d: "M28.36 8.573h-26.559c-0.568 0-1.074 0.26-1.405 0.67-0.151 0.189-0.266 0.406-0.331 0.645-0.040 0.15-0.065 0.307-0.065 0.467v19.862c0 0.984 0.805 1.783 1.797 1.783h26.559c0.992 0 1.797-0.799 1.797-1.783v-4.973h-10.662c-1.685 0-3.055-1.358-3.055-3.030v-3.964c0-0.82 0.331-1.565 0.866-2.111 0.474-0.485 1.11-0.813 1.822-0.895 0.119-0.014 0.241-0.021 0.363-0.021h10.665v-4.867c0.004-0.984-0.801-1.783-1.793-1.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a56e2",
    style: {
      fill: "var(--color2, #4a56e2)"
    },
    d: "M31.414 16.926c-0.18-0.164-0.392-0.289-0.629-0.371-0.183-0.061-0.377-0.096-0.582-0.096h-10.712c-0.992 0-1.797 0.799-1.797 1.783v3.968c0 0.984 0.805 1.783 1.797 1.783h10.712c0.205 0 0.399-0.036 0.582-0.096 0.237-0.078 0.449-0.207 0.629-0.371 0.359-0.324 0.586-0.795 0.586-1.316v-3.968c0-0.521-0.226-0.991-0.586-1.316zM23.243 20.58c0 0.492-0.402 0.891-0.898 0.891h-0.596c-0.496 0-0.898-0.399-0.898-0.891v-0.592c0-0.285 0.133-0.538 0.345-0.699 0.154-0.118 0.345-0.193 0.553-0.193h0.596c0.496 0 0.898 0.399 0.898 0.891v0.592z"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-statistics",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3h26a6 6 0 0 1 6 6v26a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V9a6 6 0 0 1 6-6zm23.5 16.56c1.28 0 2.33-1.1 2.33-2.45s-1.05-2.44-2.33-2.44a2.4 2.4 0 0 0-2.33 2.44c0 .22.02.43.08.63l-4.14 4.35c-.19-.06-.4-.09-.61-.09s-.42.02-.6.09l-2.98-3.12c.06-.2.08-.42.08-.64 0-1.34-1.05-2.44-2.33-2.44s-2.34 1.1-2.34 2.44c0 .22.03.44.09.64l-5.32 5.56a1.9 1.9 0 0 0-.6-.09c-1.28 0-2.33 1.1-2.33 2.45s1.05 2.44 2.33 2.44a2.4 2.4 0 0 0 2.33-2.44c0-.22-.02-.43-.08-.62l5.31-5.58c.19.06.4.09.6.09s.43-.03.61-.09l2.98 3.12c-.06.2-.08.42-.08.64 0 1.34 1.05 2.44 2.33 2.44s2.33-1.1 2.33-2.45c0-.22-.02-.44-.08-.63l4.15-4.34c.2.06.39.09.6.09z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-currency",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H9zm9.75 15.6c0 1.18.91 1.94 3.73 2.67s5.85 1.95 5.85 5.48c0 2.55-1.93 3.96-4.35 4.42v2.67h-3.74v-2.7c-2.38-.5-4.43-2.04-4.57-4.76h2.73c.14 1.46 1.15 2.6 3.71 2.6 2.75 0 3.36-1.36 3.36-2.22 0-1.16-.62-2.25-3.73-3-3.47-.83-5.85-2.26-5.85-5.14 0-2.4 1.94-3.96 4.35-4.49v-2.69h3.74v2.73c2.6.63 3.9 2.6 4 4.74h-2.76c-.07-1.55-.9-2.61-3.1-2.61-2.11 0-3.37.94-3.37 2.3z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H9zm9.93 21.36v8.2H12.1V21.63H8l13.67-12.3 13.66 12.3h-4.1v10.93H24.4v-8.2h-5.47z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.d4cc81eb54476d34814c182b197fdc47.svg";
export { ForwardRef as ReactComponent };